import React, { useState } from 'react';

import { Button, Icon, Stack, Text } from '@eluve/components';

import { useInterstitialFlow } from '../../hooks/useInterstitialFlow';
import { InterstitialFlowProps } from '../../types';

import { VideoWalkthroughModal } from './VideoWalkthroughModal';

// Completion happens when user closes modal (after optionally watching video)

export const VideoWalkthroughSidePanel: React.FC<
  InterstitialFlowProps
> = () => {
  const { complete } = useInterstitialFlow('VIDEO_WALKTHROUGH');
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = async () => {
    setOpen(false);
    await complete();
  };

  return (
    <>
      <Stack
        className="cursor-pointer rounded-lg border border-border-primary bg-transparent p-3"
        onClick={handleOpen}
        gap={2}
        direction="horizontal"
      >
        <Button
          variant="outline"
          className="size-10 items-center rounded-sm border-none bg-bg-tertiary"
          aria-label="Watch video walkthrough"
        >
          <Icon name="PlayCircle" size="lg" />
        </Button>
        <Stack gap={1} align="start" className="pl-3">
          <Text inline size="xs">
            Learn how to use Eluve
          </Text>
          <Text size="xs" weight="regular" color="secondary">
            Watch a 4 min video walkthrough
          </Text>
        </Stack>
      </Stack>
      {open && <VideoWalkthroughModal isOpen={open} onClose={handleClose} />}
    </>
  );
};
